import {invokeApi} from "../bl_libs/invokeApi";

/*
 * The API's geo master — the one list of countries, states and dialling codes every DQ
 * app shares. Public endpoints: no token needed. Read through utils/geo.js, which caches
 * the answer and falls back to the deprecated local list until it arrives.
 */

// GET /v1/meta/countries → { data: { version, locale, countries: [{ code, name, dial_code, has_states }] } }
export const getCountriesService = (locale) => invokeApi({
    path: '/meta/countries',
    method: 'GET',
    queryParams: locale ? {locale} : {},
});

// GET /v1/meta/countries/:code/states → { data: { version, locale, country_code, states: [{ code, name, category, parent }] } }
export const getStatesService = (country_code, locale) => invokeApi({
    path: `/meta/countries/${encodeURIComponent(country_code)}/states`,
    method: 'GET',
    queryParams: locale ? {locale} : {},
});
